import { isMobileScreen, isShortScreen, isSmallScreen, isTinyScreen } from 'common/utilities';
import { useAppSelector } from 'store';

export function useScreen() {
  const { screenHeight, screenSize, screenMode } = useAppSelector((state) => state.layout);
  return {
    isMobileScreen: isMobileScreen(screenSize),
    isShortScreen: isShortScreen(screenHeight),
    isSmallScreen: isSmallScreen(screenSize),
    isTinyScreen: isTinyScreen(screenSize),
    screenHeight,
    screenSize,
    screenMode,
  };
}
